import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Navbar from '../components/common/Navbar';
import Footer from '../components/common/Footer';

const NotFound = () => (
  <main>
    <Helmet>
      <title>Page Not Found | BusinessMate Workflow</title>
      <meta name="robots" content="noindex,follow" />
    </Helmet>
    <Navbar />
    <div className="container text-center" style={{ padding: '120px 0' }}>
      <h1 style={{ fontSize: 64, fontWeight: 700, color: '#0f172a' }}>404</h1>
      <p style={{ fontSize: 18, color: '#64748b', marginBottom: 24 }}>
        Sorry, we couldn't find the page you're looking for.
      </p>
      <Link to="/" className="btn btn-primary" style={{ background: '#06b590', border: 'none', padding: '10px 28px', borderRadius: 6, color: '#fff', textDecoration: 'none' }}>
        Back to Home
      </Link>
    </div>
    <Footer />
  </main>
);

export default NotFound;
